import { Link } from 'react-router-dom';
import ProjectButton from '../../components/UI/buttons/Button';
import styles from './Welcome.module.css';
import { motion } from 'framer-motion';

const Welcome = () => {
  return (
    <div>
      <div className={styles.welcome}>
        <motion.h1 animate={{ y: 10 }} className={styles.welcome_title}>
          Välkommen till Axelssons EL
        </motion.h1>
        <hr className={styles.hr_welcome_hr}></hr>
        <div>
          <p className={styles.welcome_para}>
            Vi är en liten firma grundad 1975. Vårt mål har alltid varit att
            leverera högsta kvalitet av tjänst till våra kunder. Vi har
            f-skattsedel på enskild firma vilket innebär för dig att priserna
            kan hållas till ett minimum. Men för den skull inte dra in på
            kvaliteten. Vår starka värdegrund för hög kvalitet kommer att
            tillfredsställa dina behov. Se våra utförda projekt för att se
            exempel att på en vad vi utför för tjänster. Eller tryck på knappen
            här:
          </p>
          <div>
            <ProjectButton>
              <Link
                to="/projects"
                style={{ color: 'inherit', textDecoration: 'inherit' }}
              >
                Projekten
              </Link>
            </ProjectButton>
          </div>
        </div>
        <div className={styles.clear}></div>
      </div>
    </div>
  );
};

export default Welcome;
